import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing12,
  spacing16,
  spacing32,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { TextInputStyled } from 'approot/shared/styles/inputs.style';
import searchIcon from 'approot/shared/icons/icon_search.svg';
import { Heading24 } from 'approot/shared/styles/typography.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const StimulusSearchField = styled(TextInputStyled)`
  border-radius: ${rem(40)};
  background: url(${searchIcon}) no-repeat left ${rem(spacing16)} center;
  background-size: ${rem(14)};
  margin-bottom: ${rem(spacing12)};
  padding-left: ${rem(spacing40)};
  width: 100%;
`;

type StimulusFiltersProps = {
  $isStacked?: boolean;
};
export const StimulusFilters = styled(Box).attrs({
  $alignItems: 'center',
  $gap: 6,
  $marginBottom: 32,
})<StimulusFiltersProps>`
  flex-wrap: ${({ $isStacked }) => ($isStacked ? 'wrap' : 'nowrap')};
`;

export const StimulusFilterGroup = styled.div`
  overflow: hidden;
  padding: ${rem(2)};
  width: 100%;
`;

export const StimulusSearchEmpty = styled.div`
  padding: ${rem(spacing32)} 0;
  text-align: center;

  img {
    margin-bottom: ${rem(spacing32)};
  }
`;

export const StimulusSearchEmptyTitle = styled(Heading24).attrs({
  as: 'h2',
  marginBottom: spacing8,
})``;
